import { Route } from 'react-router-dom';
import Menus from '../Pages/Appearance/Menus/Menus';
import MenuFooter from '../Pages/Appearance/Footer/MenuFooter';
import Layout from '../components/layout';
import MenuHeader from '../Pages/Appearance/Header/MenuHeader';
import BannerList from '../Pages/Appearance/Banner/BannerList';
import NewBanner from '../Pages/Appearance/Banner/NewBanner';
import Location from '../Pages/Appearance/Location/Location';
import Popup from '../Pages/Appearance/Popup/Popup';
import WhatsAppChat from '../Pages/Appearance/WhatsAppChat/WhatsAppChat';
import ProtectedRoute from '../components/ProtectedRoute';
import { hasPermission } from '../utils/functions';
import Tool from '../Pages/Appearance/Tool/Tool';

export const AppearanceRoutes = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/appearance" element={
      <ProtectedRoute>
        <Layout activePage='menus' menuActive={menuActive} setMenuActive={setMenuActive}>
          <Menus />
        </Layout>
      </ProtectedRoute>
    } />
    { hasPermission('menus') && 
      <Route path="/appearance/menus" element={
        <ProtectedRoute>
          <Layout activePage='menus' menuActive={menuActive} setMenuActive={setMenuActive}>
            <Menus />
          </Layout>
        </ProtectedRoute>
      } />
    }
    { hasPermission('header') && 
      <Route path="/appearance/header" element={
        <ProtectedRoute>
          <Layout activePage='header' menuActive={menuActive} setMenuActive={setMenuActive}>
            <MenuHeader />
          </Layout>
        </ProtectedRoute>
      } />
    }
    { hasPermission('footer') &&
      <Route path="/appearance/footer" element={
        <ProtectedRoute>
          <Layout activePage='footer' menuActive={menuActive} setMenuActive={setMenuActive}>
            <MenuFooter />
          </Layout>
        </ProtectedRoute>
      } />
    }

    { hasPermission('banner') &&
      <>
        <Route path="/appearance/banner" element={
          <ProtectedRoute>
            <Layout activePage='banner' menuActive={menuActive} setMenuActive={setMenuActive}>
              <BannerList />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/appearance/add-banner" element={
          <ProtectedRoute>
            <Layout activePage='add-banner' menuActive={menuActive} setMenuActive={setMenuActive}>
              <NewBanner />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/appearance/banner/:bannerId" element={
          <ProtectedRoute>
            <Layout activePage='add-banner' menuActive={menuActive} setMenuActive={setMenuActive}>
              <NewBanner />
            </Layout>
          </ProtectedRoute>
        } />
      </>
    }
    { hasPermission('location') &&
      <Route path="/appearance/location" element={
        <ProtectedRoute>
          <Layout activePage='location' menuActive={menuActive} setMenuActive={setMenuActive}>
            <Location />
          </Layout>
        </ProtectedRoute>
      } />
    }
    
    { hasPermission('popup') &&
      <Route path="/appearance/popup" element={
        <ProtectedRoute>
          <Layout activePage='popup' menuActive={menuActive} setMenuActive={setMenuActive}>
            <Popup />
          </Layout>
        </ProtectedRoute>
      } />
    }
    { hasPermission('whatsapp') &&
      <Route path="/appearance/whatsapp-chat" element={
        <ProtectedRoute>
          <Layout activePage='whatsapp-chat' menuActive={menuActive} setMenuActive={setMenuActive}>
            <WhatsAppChat />
          </Layout>
        </ProtectedRoute>
      } />
    }
    { hasPermission('tool') &&
      <Route path="/appearance/tool" element={
        <ProtectedRoute>
          <Layout activePage='tool' menuActive={menuActive} setMenuActive={setMenuActive}>
            <Tool />
          </Layout>
        </ProtectedRoute>
      } />
    }
  </>
);
